module.exports = __webpack_public_path__ + "img/logo.15a72fab.png";